import { Component, computed, inject, input, output } from '@angular/core';
import { findDashboardLeaf } from '@cumlaude/shared-dashboard-registry';
import { stripQueryParams } from '@cumlaude/shared-services';
import { FilteringTekstService } from '../../../services/filtering-tekst.service';

@Component({
	selector: 'app-pagina-card',
	templateUrl: './pagina-card.component.html',
	styleUrls: ['./pagina-card.component.scss'],
})
export class PaginaCardComponent {
	private readonly filteringTekstService = inject(FilteringTekstService);

	readonly url = input.required<string>();
	readonly titel = input<string>();
	readonly bovenschrift = input<string>();

	clickit = output<void>();

	private readonly pad = computed(() => stripQueryParams(this.url()));

	private readonly dashboardLeaf = computed(() => findDashboardLeaf(this.pad()));

	readonly weergaveTitel = computed(() => this.titel() ?? this.dashboardLeaf()?.naam ?? '');

	readonly hoofdpagina = computed(() => this.dashboardLeaf()?.hoofdpagina);

	readonly filteringTekst = computed(() => this.filteringTekstService.bepaalFilteringTekst(this.url()));
}
